export const API_ERROR_TYPE = {
  REFRESH_TOKEN_EXPIRED: "/errors/authentication/refresh/expired",
  REFRESH_TOKEN_INVALID: "/errors/authentication/refresh/invalid",
  REFRESH_TOKEN_HEADER_MISSING:
    "/errors/authentication/header/refreshtoken/missing",
  ACCESS_TOKEN_HEADER_MISSING:
    "/errors/authentication/header/accesstoken/missing",
  ACCESS_TOKEN_EXPIRED: "/errors/authentication/expired",
  ACCESS_TOKEN_INVALID: "/errors/authentication/invalid",
  REFRESH_TOKEN_FAILED: "/errors/authentication/refresh/failed",
  ACCESS_TOKEN_FAILED: "/errors/authentication/failed",
  SERVER_ERROR: "/errors/internal-server-error",
  CONFLICT_KAKAO_USER: "/errors/conflict/kakao",
  CONFLICT_NAVER_USER: "/errors/conflict/naver",
  EXCEED_POSSIBLE_REGISTRATION_NUMBER:
    "/errors/exceed-possible-registration-number",
  LIMIT_EXCEEDED: "/errors/limit-exceeded",
  // 어드민 로그인 (SMS OTP 2단계 인증)
  ADMIN_LOGIN_INVALID: "/errors/admin/login-invalid",
  ADMIN_PHONE_NOT_REGISTERED: "/errors/admin/phone-not-registered",
  ADMIN_OTP_INVALID: "/errors/admin/otp-invalid",
  ADMIN_OTP_LOCKED: "/errors/admin/otp-locked",
  ADMIN_OTP_EXPIRED: "/errors/admin/otp-expired", // challenge(10분) 자체가 없음 → 1단계로
  ADMIN_OTP_CODE_EXPIRED: "/errors/admin/otp-code-expired", // 코드(3분)만 만료 → 재발송 유도
  ADMIN_OTP_RESEND_COOLDOWN: "/errors/admin/otp-resend-cooldown",
  ADMIN_OTP_RESEND_LIMIT: "/errors/admin/otp-resend-limit",
  ADMIN_OTP_SEND_LIMIT: "/errors/admin/otp-send-limit",
};
